import Zendesk from 'react-zendesk'

import Environment from 'helpers/environment'

import useScreenSize from 'hooks/useScreenSize'
import { useSessionContext } from 'hooks/SessionContext'
import Brand from 'helpers/brand'

import { color } from 'styles/colors'

export const ZENDESK_SANDBOX_KEY = '1284bf78-73f4-48d7-b4c8-48d035023b52'
export const ZENDESK_PROD_KEY = 'c2296d90-7532-4ed6-bb8b-9c026ce16865'
const DEALER_BRAND = '360048080312'

const ZendeskWidget = () => {
  const { session } = useSessionContext()

  const screenSize = useScreenSize()

  // to see all available setting options: https://developer.zendesk.com/api-reference/widget/settings/#offset
  const setting = {
    webWidget: {
      color: { theme: color('primaryButton') },
      launcher: {
        label: { '*': screenSize === 'small' ? ' ' : 'Support' }
      }
    },
    contactForm: {
      fields: [
        { id: 'name', prefill: { '*': session.dealerName } },
        { id: 'email', prefill: { '*': session.userEmail } },
        { id: DEALER_BRAND, prefill: { '*': Brand.isCommercial() ? 'pivot' : (Brand.isASAirHome() ? 'american_standard' : 'trane') } }
      ]
    }
  }

  if (!screenSize) return null

  return (
    <Zendesk
      defer
      zendeskKey={Environment.isProduction() ? ZENDESK_PROD_KEY : ZENDESK_SANDBOX_KEY}
      {...setting}
    />
  )
}

export default ZendeskWidget
